import { StorageService } from '~/services/StorageService/StorageService';

import { CIMODE_KEY } from './constants';

export type CimodeMode = 'cimode' | 'cimode+';

const listeners = new Set<() => void>();

const isCimodeMode = (value: unknown): value is CimodeMode =>
  value === 'cimode' || value === 'cimode+';

export const getCimodeMode = (): CimodeMode | null => {
  const stored = StorageService.getItem(CIMODE_KEY);
  return isCimodeMode(stored) ? stored : null;
};

export const setCimodeMode = (mode: CimodeMode | null): void => {
  if (mode) {
    StorageService.setItem(CIMODE_KEY, mode);
  } else {
    StorageService.removeItem(CIMODE_KEY);
  }
  listeners.forEach((cb) => cb());
};

export const subscribeToCimode = (callback: () => void): (() => void) => {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
};
